import { render } from "./ViewWorkload.vue?vue&type=template&id=39c1b4a4&scoped=true"
import script from "./ViewWorkload.vue?vue&type=script&lang=js"
export * from "./ViewWorkload.vue?vue&type=script&lang=js"

import "./ViewWorkload.vue?vue&type=style&index=0&id=39c1b4a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c1b4a4"]])

export default __exports__